import './Nav.css'

function Nav() {
    return (
        <div className="row tall-row">
            <div className="col-lg-12 navigation">
                <a className="NavLink" rel="noreferrer" href="/">HOME</a>&nbsp;&nbsp;-&nbsp;&nbsp;
                <a className="NavLink" rel="noreferrer" target="_blank" href="http://cv.achrafsoltani.com">PROFILE</a>&nbsp;&nbsp;-&nbsp;&nbsp;
                <a className="NavLink" rel="noreferrer" target="_blank" href="http://journal.achrafsoltani.com">JOURNAL</a>&nbsp;&nbsp;-&nbsp;&nbsp;
                <a className="NavLink" rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/achrafsoltani/">LINKEDIN</a>&nbsp;&nbsp;-&nbsp;&nbsp;
                <a className="NavLink" rel="noreferrer" target="_blank" href="https://github.com/AchrafSoltani">GITHUB</a> 
                <hr />
            </div>
        </div>
    );
}

export default Nav;